import { apiOptionsProduction } from "./config_production";
import { apiOptionsStaging } from "./config_staging";
const USING_PROD_SERVER = false;
// export const apiServerUrl = "https://apis.neolab.net";
const apiServerUrl_stg = "https://api.stg.edu-platform.kro.kr";
const apiServerUrl_prod = "https://api.edu-platform.kro.kr";
const apiNDPUrl_stg = "https://apis.beta.neolab.net";
const apiNDPUrl_prod = "https://apis.neolab.net";
export const [nepBaseUrl, ndpBaseUrl] = (function () {
    let nepBaseUrl = apiServerUrl_stg;
    let ndpBaseUrl = apiNDPUrl_stg;
    if (USING_PROD_SERVER) {
        nepBaseUrl = apiServerUrl_prod;
        ndpBaseUrl = apiNDPUrl_prod;
    }
    return [nepBaseUrl, ndpBaseUrl];
})();
export const apiUrls = (function () {
    let nepBaseUrl = apiServerUrl_stg;
    let ndpBaseUrl = apiNDPUrl_stg;
    if (USING_PROD_SERVER) {
        nepBaseUrl = apiServerUrl_prod;
        ndpBaseUrl = apiNDPUrl_prod;
    }
    const apiUrls = getApiUrls(nepBaseUrl, ndpBaseUrl, USING_PROD_SERVER);
    return apiUrls;
})();
export const apiOptions = (function () {
    let apiOptions = apiOptionsStaging;
    if (USING_PROD_SERVER) {
        apiOptions = apiOptionsProduction;
    }
    return apiOptions;
})();
function getApiUrls(nepBaseUrl, ndpBaseUrl, isProduction) {
    const apiUrls = {
        QUERY_TEACHER_INFO: `${nepBaseUrl}/edu/v1/teacher`,
        SET_TEACHERINFO: `${nepBaseUrl}/edu/v1/teacher`,
        QUERY_STUDENTS: `${nepBaseUrl}/edu/v1/class/{eduClassId}/students`,
        QUERY_LESSONS: `${nepBaseUrl}/edu/v1/classes`,
        CREATE_LESSON: `${nepBaseUrl}/edu/v1/class`,
        QUERY_SCHOOL: `${nepBaseUrl}/edu/v1/schools`,
        ADD_STUDENTS: `${nepBaseUrl}/edu/v1/class/{eduClassId}/students`,
        GET_STROKES_FIRST: `${nepBaseUrl}/admin/v1/inkstore/search/{studentId}`,
        GET_STROKES_NEXT: `${nepBaseUrl}/admin/v1/inkstore/search/{studentId}?dataPointer={nextDataPointer}`,
        GET_WATCHLOG_URL: `${nepBaseUrl}/v1/admin/storage/{studentId}/file/{stroke_file_base}`,
        GET_MATH_TOKTOK_CATEGORY_INFO: (function () {
            if (isProduction) {
                return "https://storage.cloud.google.com/edu-platform-userstorage/common/MathCategoryInfo_2.json";
            }
            else {
                return "https://storage.cloud.google.com/edu-platform-userstorage-stg/common/MathCategoryInfo_2.json";
            }
        })(),
        QUERY_PROFILE: `${nepBaseUrl}/profile/v1/me`,
        REQUEST_NCODE_APP_CREDENTIAL: `${nepBaseUrl}/paperhub/v1/paper/ncode`,
        REQUEST_NCODE_USER_CREDENTIAL: `${nepBaseUrl}/edu/v1/paper/ncode`,
        REQUEST_NCODE_IMAGE_USER_CREDENTIAL: `${nepBaseUrl}/edu/v1/paper/ncode_image`,
        PAPER_GROUP: `${ndpBaseUrl}/paperhub/v1/papergroup`,
        GET_PAPER_GROUP: `${ndpBaseUrl}/paperhub/v1/papergroup/{paperGroupId}`,
        PAPER: `${ndpBaseUrl}/paperhub/v1/paper`,
        PAPER_PROPERTY: `${ndpBaseUrl}/paperhub/v1/paper/{paperId}/property`,
        PAPER_ATTACHMENT: `${ndpBaseUrl}/paperhub/v1/paper/{paperId}/attachment`,
        GET_PAPER_ATTACHMENT: `${ndpBaseUrl}/paperhub/v1/paper/{paperId}/attachment/{attachmentId}`,
        GET_PAPER_GROUP_ATTACHMENT: `${ndpBaseUrl}/paperhub/v1/papergroup/{paperGroupId}/attachment/{attachmentId}`,
        PAPER_GROUP_PROPERTY: `${ndpBaseUrl}/paperhub/v1/papergroup/{paperGroupId}/property`,
        NBS_BASE_URL: "https://neo-nbs.s3.ap-northeast-2.amazonaws.com/",
        NDP_SVC_CREDENTIAL: `${ndpBaseUrl}/oauth/token`,
        NEP_SVC_CREDENTIAL: `${nepBaseUrl}/oauth/token`,
    };
    return apiUrls;
}
// export const apiUrls_old = {
//   QUERY_TEACHER_INFO: `${apiServerUrl}/edu/v1/teacher`,
//   SET_TEACHERINFO: `${apiServerUrl}/edu/v1/teacher`,    // POST
//   QUERY_STUDENTS: `${apiServerUrl}/edu/v1/class/{eduClassId}/students`,  // ## is eduClassId
//   QUERY_LESSONS: `${apiServerUrl}/edu/v1/classes`,
//   CREATE_LESSON: `${apiServerUrl}/edu/v1/class`,   // body: {"year": 2021, "grade": 1, "classNum": 3}
//   QUERY_SCHOOL: `${apiServerUrl}/edu/v1/schools`,
//   ADD_STUDENTS: `${apiServerUrl}/edu/v1/class/{eduClassId}/students`,  // ## is eduClassId
//   GET_STROKES_FIRST: `${apiServerUrl}/admin/v1/inkstore/search/{studentId}`,
//   GET_STROKES_NEXT: `${apiServerUrl}/admin/v1/inkstore/search/{studentId}?dataPointer={nextDataPointer}`,
//   GET_WATCHLOG_URL: `${apiServerUrl}/v1/admin/storage/{studentId}/file/{stroke_file_base}`,
//   GET_MATH_TOKTOK_CATEGORY_INFO: (function () {
//     if (apiServerUrl === apiServerUrl_prod) {
//       return "https://storage.cloud.google.com/edu-platform-userstorage/common/MathCategoryInfo_2.json";
//     }
//     else {
//       return "https://storage.cloud.google.com/edu-platform-userstorage-stg/common/MathCategoryInfo_2.json";
//     }
//   })(),
//   QUERY_PROFILE: `${apiServerUrl}/profile/v1/me`,
//   REQUEST_NCODE_APP_CREDENTIAL: `${apiServerUrl}/paperhub/v1/paper/ncode`,
//   REQUEST_NCODE_USER_CREDENTIAL: `${apiServerUrl}/edu/v1/paper/ncode`,
//   PAPER_GROUP: `${apiServerUrl}/paperhub/v1/papergroup`,
//   GET_PAPER_GROUP: `${apiServerUrl}/paperhub/v1/papergroup/{paperGroupId}`,
//   PAPER: `${apiServerUrl}/paperhub/v1/paper`,
//   PAPER_PROPERTY: `${apiServerUrl}/paperhub/v1/paper/{paperId}/property`,
//   PAPER_ATTACHMENT: `${apiServerUrl}/paperhub/v1/paper/{paperId}/attachment`,
//   GET_PAPER_ATTACHMENT: `${apiServerUrl}/paperhub/v1/paper/{paperId}/attachment/{attachmentId}`,
//   GET_PAPER_GROUP_ATTACHMENT: `${apiServerUrl}/paperhub/v1/papergroup/{paperGroupId}/attachment/{attachmentId}`,
//   PAPER_GROUP_PROPERTY: `${apiServerUrl}/paperhub/v1/papergroup/{paperGroupId}/property`,
//   NBS_BASE_URL: "https://neo-nbs.s3.ap-northeast-2.amazonaws.com/",   // "./nbs/"
// }
// export const apiOptions_old: {
//   [key: string]: { clientId: string, clientSecret: string, grantType: string, scope?: string }
// } = {
//   neolab: {
//     // token_auth: "Basic " + btoa( clientId + ":" + clientSecret)
//     // token_auth: "Basic bmVvbGFiX2VkdV9wbGF0Zm9ybV9vYXV0aF93ZWI6Y2h5LXNlY3JldA",
//     clientId: "neolab_edu_platform_oauth_web",
//     clientSecret: "chy-secret",
//     scope: `profile.read`
//       + ` profile.write`
//       + ` userdata.read`
//       + ` userdata.write`
//       + ` storage.read`
//       + ` storage.write`
//       + ` edu.read`
//       + ` edu.write`
//       + ` application.member.admin.read`
//       + ` userdata.admin.read`
//       + ` storage.admin.read`
//       + ` storage.admin.write`,
//     grantType: "authorization_code",
//   },
//   google: {
//     // token_auth: "Basic " + btoa( clientId + ":" + clientSecret)
//     // token_auth: "Basic Z29vZ2xlX2tlcmlzcGp0X3dlYjpjaHktc2VjcmV0",
//     clientId: "google_kerispjt_web",
//     clientSecret: "chy-secret",
//     scope: `profile.read`
//       + ` profile.write`
//       + ` userdata.read`
//       + ` userdata.write`
//       + ` storage.read`
//       + ` storage.write`
//       + ` edu.read`
//       + ` edu.write`
//       + ` application.member.admin.read`
//       + ` userdata.admin.read`
//       + ` storage.admin.read`
//       + ` storage.admin.write`,
//     grantType: "authorization_code",
//   },
//   onTheLiveNEP_staging: {
//     // token_auth: btoa( clientId + ":" + clientSecret)
//     // token_auth: "bHJ2b3doNHV4czg5aGw2ZXR6NGd6bjRrZTZubHY2am1ALm5lb2xhYi5uZXQ6Slhla25KTnh0RXJoVThDQk9mUnN6QlBaV3NMdzkweXc",
//     clientId: "lrvowh4uxs89hl6etz4gzn4ke6nlv6jm@.neolab.net",
//     clientSecret: "JXeknJNxtErhU8CBOfRszBPZWsLw90yw",
//     grantType: "client_credentials",
//   },
//   onTheLiveNDP_staging: {
//     // token_auth: btoa( clientId + ":" + clientSecret)
//     // token_auth: "????",
//     clientId: "liugicjhgvrk3nqz48bccm88k29arm46@paper.neolab.net",
//     clientSecret: "HrGEmyQjxwJyvP1S5wzQW0NTNfq44Mvr",
//     grantType: "client_credentials",
//   },
//   onTheLiveNDP_production: {
//     // token_auth: btoa( clientId + ":" + clientSecret)
//     // token_auth: "????",
//     clientId: "mlk4v2bgmkk0tn6ijjmkfio8afa55ut4@paper.neolab.net",
//     clientSecret: "zCFtDuiyXqWnzY0aI5JUfOAVlT8K7ZAQ",
//     grantType: "client_credentials",
//   }
// }
// https://jess2.xyz/JavaScript/variable-regex/
export function completeApiUrl(url, args) {
    let ret = url;
    Object.keys(args).forEach((key) => {
        const regexp = new RegExp(`\\{${key}\\}`, "gi");
        ret = ret.replace(regexp, args[key]);
    });
    const regexp = /\{([^{}]*)\}/g;
    // const rest= ret.match(regexp);
    const rest = regexp.exec(ret);
    if (rest) {
        throw new Error(`The parameter, ${rest[1]}, has not been given.`);
    }
    return ret;
}
export function generateTokTokPageName(pageNo) {
    if (pageNo - 2 > 0)
        return `${pageNo - 2}쪽`;
    return "";
}
//# sourceMappingURL=configuration.js.map